import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-editar-observacao-clinico',
  templateUrl: './editar-observacao-clinico.component.html',
  styleUrls: ['./../modals-inserir.scss']
})
export class EditarObservacaoClinicoComponent implements OnInit {

  dadosConsulta: FormGroup = new FormGroup({
    obs: new FormControl(''),
    id: new FormControl(null)
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditarObservacaoClinicoComponent>
  ) { }

  ngOnInit() {

    this.dadosConsulta.patchValue({
      obs: this.data.obs ? this.data.obs : '',
      id: this.data.id ? this.data.id : null
    })

  }

  Salvar() {

    var dados_consulta = {
      obs: this.dadosConsulta.controls.obs.value,
      id: this.dadosConsulta.controls.id.value
    }

    this.dialogRef.close({ ...dados_consulta });

  }

}
